import React from 'react';
import Welcome from './Welcome';

const Feed = () => (
  <Welcome />
);

export default Feed;
